import React, { useState, useEffect, useRef } from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

import PrintIcon from "@material-ui/icons/Print";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import moment from "moment";
import BiztranControls from "../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../hooks/UseFetchData"
import Modal_Frame from "../biztran_controls/Modal_Frame";
import { DatePickerInput } from 'rc-datepicker';
import Session from "react-session-api";
import { Save } from "@material-ui/icons";
import AddEditExpense from "../Approvels/AddEditExpense";
import AddExpense from "./AddExpense";

const todate = new Date()
const fromdate = todate.getFullYear() - 1 + '/04/01';

// function useApiRef() {
//   const apiRef = useRef(null);
//   const _columns = useMemo(
//     () =>
//       columns.concat({
//         field: "__HIDDEN__",
//         width: 0,
//         renderCell: (params) => {
//           apiRef.current = params.api;
//           return null;
//         },
//       }),
//     [columns]
//   );
//   return { apiRef, columns: _columns };
// }

const EditExpense = (props) => {
    //debugger;
    //const classes = useStyles();
    const [TravelRequestNo, setTravelRequestNo] = useState('');
    const [TravelRequestID, setTravelRequestID] = useState('');
    const [TravelRequestDate, setTravelRequestDate] = useState('');
    const [UserName, setUserName] = useState('');
    const [LocationToTravel, setLocationToTravel] = useState('');
    const [PurposeOfTravel, setPurposeOfTravel] = useState('');
    const [ExpenseSheetCreatedOn, setExpenseSheetCreatedOn] = useState('');
    const [ExpenseDate, setExpenseDate] = useState('');
    const [EmpID, setEmpID] = useState('');
    const [ExpenseID, setExpenseID] = useState('');
    const [Status, setStatus] = useState('');
    const [EmpName, setEmpName] = useState('');
    const [AccountsApprovedByID, setAccountsApprovedByID] = useState(Session.get("UID"));
    const [PaidAmount, setPaidAmount] = useState('');
    const [AccountsApprovedOn, setAccountsApprovedOn] = useState('')
    const [TravelFrom, setTravelFrom] = useState('');
    const [ModeOfTravelID, setModeOfTravelID] = useState('');
    const [ApprovedBy, setApprovedBy] = useState('');
    const [ApprovedOn, setApprovedOn] = useState('');
    const [AccApprovedBy, setAccApprovedBy] = useState(Session.get("UserName"));
    const [responseList, ListfetchData] = UseFetchData();
    const [AccApprovedOn, setAccApprovedOn] = useState('');
    const [PlannedAmount, setPlannedAmount] = useState('');
    const [tolExpAmount, settolExpAmount] = useState('');
    const [TotalExpAmount, setTotalExpAmount] = useState('');
    const [tolExpAppAmount, settolExpAppAmount] = useState('');
    const [tolAccAppAmount, settolAccAppAmount] = useState('');
    const [isOpen, setOpen] = useState(false);
    const [isOpenExpense, setOpenExpense] = useState(false);

    const [PaidOn, setPaidOn] = useState('');
    const [TravelReportFile, setTravelReportFile] = useState(null);
    const [pagename, setpagename] = useState(props.pagename);
    const [flag, setflag] = useState(props.pagename == "Home" ? true : true);
    const [flag01, setflag01] = useState(false);
    // console.log(props.poppopupData.[FunctionLocation);
    const [TotalPaidAmount, setTotalPaidAmount] = useState('');
    const [PaymentDetails, setPaymentDetails] = useState('');
    const [SelectedPdf, setSelectedpdf] = useState(null);
    const [MainState, setMainState] = useState('initial');
    const [PdfUploaded, setPdfUploaded] = useState(0);
    const [rows, setRows] = useState([]);
    const [LocationFromTravel, setTravelFromLocation] = useState([]);
    const [columns, setColumns] = useState([]);
    const [response, fetchData] = UseFetchData();
    const [responseAccAp, AccApfetchData] = UseFetchData();
    const [response01, fetchData01] = UseFetchData();
    const [responseprint, fetchDataprint] = UseFetchData();
    const [responseApprove, fetchDataapprove] = UseFetchData();
    const [responseReject, fetchDataReject] = UseFetchData();
    const [responseattachment, attachmentfetchData] = UseFetchData();
    const [responseExpense, fetchExpenseData] = UseFetchData();
    const [responseFile, fetchDataFile] = UseFetchData();
    const [responseDeleteFile, fetchdeleteFile] = UseFetchData();

    // const fromdate = new Date()
    const [ToDate, setToDate] = useState('');
    const [FromDate, setFromDate] = useState('');
    const [Description, setDescription] = useState('');
    const [ApproxExpAmt, setApproxExpAmt] = useState('');
    const [defaultToDate, setdefaultToDate] = useState('');
    const [ExpenseCount, setExpenseCount] = useState('');
    const [Remarks, setRemarks] = useState('');
    const [ApprovalStatus, setApprovalStatus] = useState([]);
    const [shoppingItems1, setShoppingItems] = useState([]);
    const [At1ID, setAt1ID] = useState(null);


    const [label, setlabel] = useState(false);
    const [label01, setlabel01] = useState(false);
    const [label02, setlabel02] = useState(false);
    const [label03, setlabel03] = useState(false);
    const [label04, setlabel04] = useState(false);
    const [label05, setlabel05] = useState(false);
    const [label06, setlabel06] = useState(false);
    const [label07, setlabel07] = useState(false);

    const poppopupData = () => {
        //debugger;
        // const bodyFormData = new FormData();
        // bodyFormData.append("TravelRequestID", props.TravelRequestID);
        // ListfetchData("Dashboard/GetbyID", bodyFormData);
        const bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", props.TravelRequestID);
        // bodyFormData.append("EmpID", "bd223d43-4589-11ed-ad55-42010aa00007");
        // bodyFormData.append("CategoryID", "63456028-908F-2E24-72B4-DA48551E7AE8");
        // bodyFormData.append("PageName", 'ApprovalList');
        ListfetchData("ExpMangt/TravelRequestListWeb", bodyFormData)
    }

    const popupGrid = () => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", props.TravelRequestID);
        fetchData("Dashboard/ExpenseList", bodyFormData);

    }

    useEffect(() => {
        debugger;
        if (responseattachment != undefined && responseattachment.length > 0) {
            setAt1ID(responseattachment[0].AttachmentsID);
            setTravelReportFile('TravelReportUploaded');
            window.open(responseattachment[0].ServerFilePath);
        }
    }, [responseattachment])



    const submitApprove = () => {
        debugger;
        if ((TravelReportFile !== null && TravelReportFile !== '')) {
        const bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", props.TravelRequestID);
        bodyFormData.append("TravelRequestNo", TravelRequestNo);
        bodyFormData.append("EmpID", Session.get("UID"));
        fetchData("ExpMangt/ExpApprovalReq", bodyFormData);

        //  alert("Please select Travel Visit report!..");
         } else {
            alert("Please select Travel Visit report!..")
        }
    }
    useEffect(() => {
        //debugger;
        if ((response.Response === true)) {
            alert('Data Saved Succesfully.');
            // setRevised("false");
            props.setOpen(false);
            props.PopulateData();
        }
        else if (response.Response === false) {
            alert('Failed..');
        }
    }, [response])

    const ExpensesListData = () => {
        //debugger;
        const bodyFormData = new FormData();
        bodyFormData.append("ExpenseID", "");
        bodyFormData.append("TravelRequestID", props.TravelRequestID);
        bodyFormData.append("EmpID", Session.get("UID"));
        fetchExpenseData("ExpMangt/ExpenseListWeb", bodyFormData);
    }

    const OpenExpense = () => {
        //debugger;
        setOpenExpense(true)
    }

    const submitReject = () => {
        debugger;
        const bodyFormData = new FormData();
        if (Remarks !== "") {
            bodyFormData.append("TravelRequestID", props.TravelRequestID);
            bodyFormData.append("ApprovalRemarks", Remarks);
            bodyFormData.append("ApprovalStatus", "Exp Rejected");
            bodyFormData.append("ApprovedByID", Session.get("UID"));
            fetchDataReject("ExpMangt/ApproveTravelRequestWeb", bodyFormData);
        }
        else {
            alert('Please Enter Remarks');
        }
    }

    const handleUploadClick = (event) => {
        try {
            var Type;
            if (event.target.name === "Attachment 1") {
                Type = "Attachment1"
            } else if (event.target.name === "Attachment 2") {
                Type = "Attachment2"
            } else if (event.target.name === "Attachment 3") {
                Type = "Attachment3"
            } else if (event.target.name === "TravelVisitReport") {
                Type = "Travel Visit Report"
            }
            var file = event.target.files[0];
            var FName = file.name;
            var FileExtension = file.name.split('.')[1];
            var Base64 = null;
            var base64Data;
            const reader = new FileReader();
            var url = reader.readAsDataURL(file);
            reader.onloadend = function (e) {
                setSelectedpdf([reader.result]);
                Base64 = [reader.result];
                base64Data = Base64[0].split(",")[1]
                setMainState("uploaded")
                if (MainState === "uploaded") {
                    setPdfUploaded(1);
                    setSelectedpdf(event.target.files[0])
                }
                uploadImage(base64Data, Type, FName, FileExtension);
            };

        } catch (error) {
            console.log(error);
        }

    }

    const uploadImage = async (data, Attachmentno, FName, FileExtension) => {
        debugger;
        DeleteFile(Attachmentno)
        var Type;
        if (FileExtension == "jpg") {
            Type = "Image";
        } else if (FileExtension == "pdf") {
            Type = "PDF";
        }
        const bodyFormData = new FormData();
        var Udata = data
        var st = ""
        bodyFormData.append("App", "App");
        bodyFormData.append("attachmentNo", Attachmentno);
        bodyFormData.append("ExpenseID", ExpenseID);
        bodyFormData.append("TravelRequestID", props.TravelRequestID);
        bodyFormData.append("EmpID", Session.get("UID"));
        bodyFormData.append("Base64Image", Udata);
        bodyFormData.append("FileName", FName);
        bodyFormData.append("Type", Type);
        bodyFormData.append("FileExtension", FileExtension);
        fetchDataFile("ExpMangt/UploadImageNew", bodyFormData);
    };

    const Print = () => {
        debugger;
        if (props.TravelRequestID != "" && props.TravelRequestID != null && props.TravelRequestID != undefined) {
            const bodyFormData = new FormData();
            // bodyFormData.append("TravelRequestID", props.TravelRequestID);
            // fetchDataprint("Dashboard/PDFGenerate", bodyFormData);
            bodyFormData.append("ExpenseID", '');
            bodyFormData.append("TravelRequestNo", props.TravelRequestID);
            attachmentfetchData("ExpMangt/GetAttachmentsWeb", bodyFormData);

        }
    }

    const DeleteFile = (TravelVisitReport) => {
        var id;
        if (TravelVisitReport == "Travel Visit Report") {
            id = props.TravelRequestID
        } else {
            id = ExpenseID;
        }

        if (id !== null) {
            const bodyFormData = new FormData();
            bodyFormData.append("RefDocId", id);
            bodyFormData.append("Type", TravelVisitReport)
            fetchdeleteFile("ExpMangt/DeleteFileWeb", bodyFormData);
        }
    }

    useEffect(() => {
        debugger;
        if (responseFile != '' || responseFile != undefined) {
            if (responseFile.Response == true) {
                debugger;
                alert('File Uploaded Succesfully.');
                setTravelReportFile('TravelReportUploaded');
            } else if (responseFile.Response == false) {
                debugger;
                alert('File Uploaded Failed.');

            }
        }
    }, [responseFile])

    const SaveExpense = (value) => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", value.TravelRequestID);
        bodyFormData.append("EmpID", Session.get("UID"));
        bodyFormData.append("ExpenseID", value.id);

        if (value.AccountsRemarks !== null && value.AccountsRemarks !== "") {
            bodyFormData.append("AccountsRemarks", value.AccountsRemarks);
        } else {
            bodyFormData.append("AccountsRemarks", "");
        }
        if (value.AccountsApprovedAmt !== null && value.AccountsApprovedAmt !== "") {
            if (!isNaN(+value)) {
                alert('Please Enter Numeric Value only !..');
                return;
            }
            else {
                bodyFormData.append("AccountsApprovedAmt", value.AccountsApprovedAmt);
            }
        } else {

            alert('Please Enter Accounts Approved Amount !...');
            return;
        }

        AccApfetchData("Dashboard/ExpAccApproval", bodyFormData);
    }

    useEffect(() => {
        //debugger;
        poppopupData();
        popupGrid();
        ExpensesListData();
        console.log("pagename", props.pagename);
    }, [])

    const handleCardClick = (item) => {
        // Handle the click event for the card here
        // You can access the item associated with the clicked card
        console.log('Card clicked:', item.ExpenseID);
        setOpen(true);
        setExpenseID(item.ExpenseID);
    };

    useEffect(() => {
        //debugger;
        if ((responseApprove.Response === true)) {
            alert('Data Saved Succesfully.');
            props.setOpen(false);
            props.PopulateData();
        }
        else if (responseApprove.Response === false) {
            alert('Failed.');
        }
    }, [responseApprove])

    useEffect(() => {
        //debugger;
        if ((responseReject.Response === true)) {
            alert('Data Saved Succesfully.');
            props.setOpen(false);
            props.PopulateData();
        }
        else if (responseReject.Response === false) {
            alert('Failed.');
        }
    }, [responseReject])

    useEffect(() => {
        if (response01.Response == true) {
            //debugger;
            props.setOpen(false);
            props.PopulateData();
        }

    }, [response01])


    const submitForm = () => {
        if (pagename !== "Home") {
            const bodyFormData = new FormData();
            bodyFormData.append("TravelRequestID", props.TravelRequestID);
            bodyFormData.append("PaidOn", PaidOn);
            bodyFormData.append("TotalPaidAmount", TotalPaidAmount);
            bodyFormData.append("PaymentDetails", PaymentDetails);
            fetchData01("Dashboard/PaymentUpdate", bodyFormData);
        } else {
            const bodyFormData = new FormData();
            bodyFormData.append("TravelRequestID", props.TravelRequestID);
            bodyFormData.append("EmpID", Session.get("UID"));
            fetchData01("Dashboard/AccApproval", bodyFormData);
        }


    };

    // useEffect(() => {
    //     debugger;
    //     // comboData("")
    //     const bodyFormData = new FormData();
    //     bodyFormData.append("ExpenseID", '');
    //     bodyFormData.append("TravelRequestNo", props.TravelRequestID);
    //     attachmentfetchData("ExpMangt/GetAttachmentsWeb", bodyFormData);
    // }, [])






    useEffect(() => {
        if (responseList !== undefined && responseList.length > 0) {
            //debugger;
            setTravelRequestNo((responseList[0].TravelRequestNo));
            setTravelRequestDate(moment(responseList[0].TravelRequestDate).format('DD-MMM-yyyy'));
            setUserName(responseList[0].EmpName);
            setLocationToTravel(responseList[0].LocationToTravel);
            setTravelFromLocation(responseList[0].LocationFromTravel);
            setPurposeOfTravel(responseList[0].PurposeOfTravel);
            setExpenseSheetCreatedOn(responseList[0].ExpenseSheetCreatedOn);
            setEmpName(responseList[0].EmpName);
            setApprovedBy(responseList[0].ApprovedBy);
            setPlannedAmount(responseList[0].ApproxExpAmount);
            setApprovedOn(responseList[0].ApprovedOn != null && responseList[0].ApprovedOn != "" ? moment(responseList[0].ApprovedOn).format('DD-MMM-yyyy') : null);
            setApproxExpAmt(responseList[0].ApproxExpAmount);
            settolExpAppAmount(responseList[0].TotalApprovedAmount);
            settolAccAppAmount(responseList[0].TotalAccAppAmt);
            setPaidOn(responseList[0].PaidOn != null && responseList[0].PaidOn != "" ? moment(responseList[0].PaidOn).format('DD-MMM-yyyy') : null);
            setTotalPaidAmount(responseList[0].TotalPaidAmount);
            setPaymentDetails(responseList[0].PaymentDetails);
            setStatus(responseList[0].ApprovalStatus);
            setFromDate(responseList[0].FromDate != null && responseList[0].FromDate != "" ? moment(responseList[0].FromDate).format('DD-MMM-yyyy') : null);
            setToDate(responseList[0].ToDate != null && responseList[0].ToDate != "" ? moment(responseList[0].ToDate).format('DD-MMM-yyyy') : null);
            if (responseList[0].ApprovalStatus == "Exp Approved") {
                setflag01(true)
                setflag(false)

            }
            setApprovalStatus(responseList[0].ApprovalStatus);
            setDescription(responseList[0].Description);
            setExpenseCount(responseList[0].NoofExp)
            setTotalExpAmount(responseList[0].TotalExpenseAmount)
        }
    }, [responseList]);


    const openPath = (row) => {
        debugger;
        window.open(row.formattedValue);

    };

    useEffect(() => {
        // Assuming 'response' contains your API response data
        debugger;
        console.log("responseeeeee: ", responseExpense);

        if (Array.isArray(responseExpense)) {
            // Map the response data to the 'shoppingItems' format
            const newShoppingItems = responseExpense.map((item) => ({
                ExpenseID: item.ExpenseID,
                ExpDate: item.ExpenseDate,
                ExpType: item.ExpenseType, // Adjust this based on your API response
                UpperCeiling: item.UpperCeiling,
                ExpAmount: item.ExpenseAmount,
                ApprovedAmt: item.ApprovedAmt
                // Add other properties as needed
            }));

            // Update the 'shoppingItems' state with the mapped data
            setShoppingItems(newShoppingItems);
        }
    }, [responseExpense]);






    return (<div>
        <Formik initialValues={{
            TravelRequestNo: TravelRequestNo, ExpenseDate: ExpenseDate, EmpID: EmpID, TravelFrom: TravelFrom, ModeOfTravelID: ModeOfTravelID,
            ApprovedBy: ApprovedBy, ApprovedOn: ApprovedOn, AccApprovedBy: AccApprovedBy, AccApprovedOn: AccApprovedOn, PlannedAmount: PlannedAmount, tolExpAmount: tolExpAmount,
            PaidOn: PaidOn, PaidAmount: PaidAmount, PaymentDetails: PaymentDetails
        }}
            onSubmit={() => submitForm()}
            enableReinitialize>
            {formik => {
                return <Form>
                    <Grid item xs={12} spacing={1} container direction="row">
                        <Grid item xs={12} spacing={1} container direction="row">
                            <Grid item xs={4} sm={4} md={2} lg={2}>
                                <label
                                    htmlFor={"TravelRequestNo"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"TR No : "}
                                </label>
                            </Grid>
                            <Grid item xs={8} sm={8} md={4} lg={4}>
                                <label
                                    htmlFor={"TravelRequestNo"}
                                    style={{
                                        // display: "block",
                                        width: "100%",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {TravelRequestNo}
                                </label>
                            </Grid>
                            <Grid item xs={4} sm={8} md={2} lg={2}>
                                <label
                                    htmlFor={"ExpenseDate"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Date : "}
                                </label>
                            </Grid>
                            <Grid item xs={8} sm={8} md={4} lg={4}>
                                <label
                                    htmlFor={"TravelRequestDate"}
                                    style={{
                                        // display: "block",
                                        width: "100%",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {TravelRequestDate}
                                </label>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                                <label
                                    htmlFor={"EmpID"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Employee Name: "}
                                </label>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                                <label
                                    htmlFor={"EmpName"}
                                    style={{
                                        // display: "block",
                                        width: "100%",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {EmpName}
                                </label>
                            </Grid>

                        </Grid>

                        <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row">
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                                <label
                                    htmlFor={"TravelFromLocation"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"From Location :"}
                                </label>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                                <label
                                    htmlFor={"LocationFromTravel"}
                                    style={{
                                        // display: "block",
                                        fontWeight: "bold",
                                        width: "100%",
                                    }}
                                >
                                    {LocationFromTravel}
                                </label>
                            </Grid>
                            <Grid item xs={6}>
                                <label
                                    htmlFor={"TravelFrom"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"To Location:"}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <label
                                    htmlFor={"LocationToTravel"}
                                    style={{
                                        // display: "block",
                                        fontWeight: "bold",
                                        width: "100%",
                                    }}
                                >
                                    {LocationToTravel}
                                </label>
                            </Grid>
                            <Grid item xs={6}>
                                <label
                                    htmlFor={"ModeOfTravelID"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Purpose :"}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <label
                                    htmlFor={"PurposeOfTravel"}
                                    style={{
                                        // display: "block",
                                        fontWeight: "bold",
                                        width: "100%",
                                    }}
                                >
                                    {PurposeOfTravel}
                                </label>
                            </Grid>

                        </Grid>
                        <Grid item xs={12} spacing={1} container direction="row">
                            <Grid item xs={6}>
                                <label
                                    htmlFor={"ApprovedBy"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"From Date : "}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <label
                                    htmlFor={"ApprovedBy"}
                                    style={{
                                        // display: "block",
                                        fontWeight: "bold",
                                        width: "100%",
                                    }}
                                >
                                    {FromDate}
                                </label>
                            </Grid>
                            <Grid item xs={6}>
                                <label
                                    htmlFor={"ApprovedOn"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"To Date :"}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <label
                                    htmlFor={"ApprovedOn"}
                                    style={{
                                        // display: "block",
                                        fontWeight: "bold",
                                        width: "100%",
                                    }}
                                >
                                    {ToDate}
                                </label>
                            </Grid>

                        </Grid>

                        <Grid item xs={12} spacing={1} container direction="row">

                            <Grid item xs={6}>
                                <label
                                    htmlFor={"ApproxExpAmt"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Description :"}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <label
                                    htmlFor={"ApproxExpAmt"}
                                    style={{
                                        // display: "block",
                                        width: "100%",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {Description}
                                </label>
                            </Grid>


                            <Grid item xs={6}>
                                <label
                                    htmlFor={"tolExpAmount"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Approx Amount :"}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <label
                                    htmlFor={"tolExpAmount"}
                                    style={{
                                        fontWeight: "bold",
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {ApproxExpAmt}
                                </label>
                            </Grid>

                            <Grid item xs={6}>
                                <label
                                    htmlFor={"tolExpAmount"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Expense Count :"}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <label
                                    htmlFor={"tolExpAmount"}
                                    style={{
                                        fontWeight: "bold",
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {ExpenseCount}
                                </label>
                            </Grid>

                            <Grid item xs={6}>
                                <label
                                    htmlFor={"tolExpAmount"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Total Amount :"}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <label
                                    htmlFor={"tolExpAmount"}
                                    style={{
                                        fontWeight: "bold",
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {TotalExpAmount}
                                </label>
                            </Grid>
                            <Typography variant="body2" marginTop={1}>
                                <a href="javascript:;" onClick={() => { OpenExpense(); }} >Add New Expense</a>
                                <span style={{ marginLeft: '20px' }}></span>
                                <a href="javascript:;" onClick={() => { Print(); }} >View Travel Visit Report</a>
                            </Typography>
                            <Grid item xs={12}>
                                <label
                                    htmlFor={"tolExpAmount"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Upload Travel Visit Report"}
                                </label>
                                {/* <a href="javascript:;" onClick={() => { Print(); }} >Travel Visit Report</a> */}
                                <input type='file'
                                    onChange={handleUploadClick}
                                    name="TravelVisitReport"
                                // className={classes.input}
                                //id={ props.id }   multiple   
                                />
                            </Grid>



                        </Grid>

                        {/* <BiztranControls.DataGrid
                            rowHeight={25}
                            headerHeight={34}
                            rows={rows}
                            columns={columns}
                            rowsPerPage={5}
                            pageSize={5}
                            checkboxSelection={false}
                            autoHeight={true}
                            autoPageSize={true}
                            Width="107%"

                            Height="250px"
                            // hideFooter={true}
                            // rowsPerPageOptions={[5, 10]}
                            hideFooterPagination={false}
                        /> */}

                        <Grid container spacing={2}>
                            {shoppingItems1.map((item) => (

                                <Grid key={item.id} item xs={12} sm={12} md={12} lg={12}>
                                    <div
                                        onClick={() => handleCardClick(item)} // Attach the click event handler to the div
                                        style={{ cursor: 'pointer' }} // Change cursor to indicate it's clickable
                                    >
                                        <Card style={{ border: '1px solid black', backgroundColor: "#F2E9E9" }}>
                                            <CardContent>
                                                <b>Exp Date : </b>{item.ExpDate != null ? moment(item.ExpDate).format("DD/MMM/YYYY") : ""}
                                                <span style={{ marginLeft: '20px' }}></span>
                                                <b>Exp Type : </b>{item.ExpType}
                                                <Typography variant="body2" marginTop={1}>
                                                    <b>Upper Ceiling : </b> {item.UpperCeiling}
                                                    <span style={{ marginLeft: '20px' }}></span>
                                                    <b>Exp Amount : </b>{item.ExpAmount}
                                                    <span style={{ marginLeft: '20px' }}></span>
                                                    <b>Apv Amount : </b>{item.ApprovedAmt}
                                                </Typography>

                                            </CardContent>
                                        </Card>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>





                        <Grid item xs={12}>
                            <div style={{ width: '100%' }}>
                                <div style={{ display: 'flex', marginTop: 5, justifyContent: 'center', alignContent: "center" }}>

                                    <BiztranControls.Button
                                        text="Submit"
                                        startIcon={<SaveIcon />}
                                        onClick={submitApprove}
                                        style={{ width: "600" }}
                                        //type="submit"
                                        disabled={props.Status != "TR Approved" && props.Status != "Exp Approval" && props.Status != "Travelling"}
                                    />

                                </div>
                            </div>
                        </Grid>
                    </Grid>

                    <Modal_Frame
                        title="Add/Edit Expense"
                        maxWidth="sm"
                        isOpen={isOpen}
                        setOpen={setOpen}
                    >
                        <AddExpense
                            TravelRequestID={props.TravelRequestID}
                            ExpenseID={ExpenseID}
                            setOpen={setOpen}
                            PopulateData={props.PopulateData}
                            ExpenseData={ExpensesListData}
                            Status={props.Status} // Pass Status to AddExpense
                        />
                    </Modal_Frame>

                    <Modal_Frame
                        title="Add Expense"
                        maxWidth="sm"
                        isOpen={isOpenExpense}
                        setOpen={setOpenExpense}
                    >
                        <AddExpense
                            TravelRequestID={props.TravelRequestID}
                            ExpenseID={''}
                            setOpen={setOpenExpense}
                            //PopulateData={props.PopulateData}
                            PopulateData={ExpensesListData}
                            Status={props.Status} // Pass Status to AddExpense
                        />
                    </Modal_Frame>
                </Form>
            }}
        </Formik>

    </div >)

}
export default EditExpense;